import createToast from './createToast'

export interface Args {
  tCommon: (a: string) => string
  callback: Function // eslint-disable-line
  useZip?: boolean
}

export default ({ tCommon, callback, useZip = false }: Args) =>
  (acceptedFiles: File[]) => {
    let errorShown = false

    const baseMimeTypes = [
      'pdf',
      'jpeg',
      'jpg',
      'png',
      'vnd.ms-excel',
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'xlsx',
      'xls',
      'ods',
      'csv'
    ]

    const extendedMimeTypes = [
      ...baseMimeTypes,
      'vnd.ms-outlook',
      'zip',
      'message/rfc822',
    ]

    const validTypes = useZip ? extendedMimeTypes : baseMimeTypes

    // build the regex for allowed mime types
    const mimeRegex = new RegExp(
      `(${validTypes.map((type) => type.replace('.', '\\.')).join('|')})$`,
      'i'
    )

    const filteredAcceptedFiles = acceptedFiles.filter((file) => {
      const valid = mimeRegex.test(file.type)

      if (!valid && !errorShown) {
        createToast('error', tCommon('filesDropInputWrongFormat'))
        errorShown = true
      }

      return valid
    })

    callback(filteredAcceptedFiles)
  }
